// Response data's from server
let tangent_facemap_data;

var tangent_selfie_id;

// Product ID to single Variant ID mapping
var tangent_selected_product_map;

var default_addToCartText = "Add to cart";
var default_addedToCartText = "Added to Cart!";
var out_of_stock_text = "Out of Stock";
var no_products_found_text ="No products found. Please retry!";
const default_add_all_to_cart_text = "Add All to Cart"

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};

// Tab title mapping based on tags
var tabs_title_mapping={
  section_starter_routine:"Starter Routine",
  section_individual_product:"Individual Products",
  section_full_light_protection:"Full-Light Protection",
  section_additional_skinconcern:"Additional Concerns",
  section_treatment_recommendation:"Facial Treatments",
  section_body_care:"Massage & Body"
}

const SELLING_PLAN_MAP = {
  '42114417885249': 3379265601
};

// Message for each conditions
var condition_text_mapping = {
  dark_circles:"Prone to dark circles here? Try our <a href='/products/cbe-botanicals-pack-your-bags-anti-puff-eye-gel' target='_blank'><u>Pack Your Bags</u></a>",
  wrinkles:"Prone to wrinkles here? Try our <a href='/products/sleep-on-it-retinol-serum' target='_blank'><u>Retinol Sleep On It</u></a>",
  rosacea:"Prone to rosacea here? Try our <a href='/products/cbe-botanicals-fruity-peptide-soothing-antioxidant-serum' target='_blank'><u>Fruity Peptide</u></a>",
  texture:"Prone to texture here? Try our <a href='/products/brighten-the-day-skin-brightening-serum' target='_blank'><u>Brighten the Day</u></a>",
  darkspots:"Prone to darkspots here? Try our <a href='/products/brighten-the-day-skin-brightening-serum' target='_blank'><u>Brighten the Day - Skin Brightening Serum</u></a>",
  acne:"Prone to acne here? Try our <a href='/products/plla-h2-cell-repair-moisturizer-acne-prone' target='_blank'><u>HOP+ Promoter Repair Cell Moisturizer</u></a>"
}

// Add default image url here
var tangent_default_selfie_image_url="https://file.tangent.ai/quiz-content/merchants/christine-byer-esthetics-boutique/image/6043991080572122-default-selfie-image.jpg";
var default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

var tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
var tangent_client_domain_url = window.location.origin;
var tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
var tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message"); 


window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function attachScrollToEvent(){
    document.querySelectorAll(".scroll-to-btn").forEach((element)=>{
        element.addEventListener("click", ()=>{
            const target = document.getElementById(element.dataset.scrollto);
            if(target){
                const top = target.getBoundingClientRect().top + window.pageYOffset - 40 ;
                window.scrollTo({
                    top,
                    behavior: 'smooth'
                });
            }
        })
    })
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;


    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }
    // API call for facemapping
    if(response["selfie_id"]!=null){
      setSelfieId(response["selfie_id"]);
      getSelfieMapping(response["selfie_id"]);
      document.getElementById("tangent_score_description").style.display="block";
      document.getElementById("skin-health-title-container").style.display="block";
    }

    appendSectionBelowSelfie(response.tags);
  
    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);

      // Setting 1st tab active by default
      document.querySelector("#tab-wrapper").style.display="block";
    }
    
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }


    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
      enableButtonListener();
      loadElementsOnResponseData(); 
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }

    attachScrollToEvent();
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          const variant = getSelectedVariant(product, selected_variants[product.id]);
            
          // Track selected product variant
          tangent_selected_product_map[product.id] = variant.id;
          
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = product_html;

          // Append the created product HTML to the fragment
          while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function getProductHTML(product, index, variant, section, sections) {
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant.image_id, product);
  const variant_product_url = `${tangent_client_domain_url}/products/${product.handle}?variant=${variant.id}`;
  let variantTitle= "("+variant.title+")";
  if(variant.title=="Default Title"){
    variantTitle="";
  }
  let buttonClass="";
  if(isProductAvailable(product, variant)){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
  }
  else{
    default_addToCartText = out_of_stock_text;
    buttonClass ="disable-button";
  }
  let customSubText="";
  if(product.id=="7550463344705"){
    customSubText = `<p id="tangent-custom-subttext">Monthly Instant CBE Cash</p>`
  }
  // Product View HTML using template literals
  const product_html = `
    <div class="tangent-product-card">
      <div class="tangent-product-image-text-content">
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          <p class="tangent-product-title tangent_product_title_text"><b>${product.title}</b></p>
          ${customSubText}
        </a>
      </div>
      <div class="tangent-product-button-container">
        <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${variant.price}</p>
        <button class="tangent-product-add-btn-wrapper tangent_add_to_cart_button product-buy-buttons--cta btn ${buttonClass} btn btn--solid" id="${variant.id}">${default_addToCartText}</button>
      </div>
    </div>
  `;
  
  return product_html;
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => variant.id === selectedVariantId) || productVariants[0];
  }
  
  return productVariants[0];
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status !== "active") {
      return false;
  }
  return variant.available_for_sale;
}

const appendSectionBelowSelfie = (tags) =>{
  const section_container = createElement('tangent_recommendation_info', 'div');
  appendElementNextTo('tangent_score_description',section_container);
}

const getTakeQuizAgainButton = (tags) => {
  const matchingQuizUrl = findFirstMatchingQuiz(quizURLData, tags);
  if(matchingQuizUrl){
    const quizRetakeButton = createElement('tangent-retake-quiz-button', 'a');
    quizRetakeButton.innerHTML = "START A NEW QUIZ";
    quizRetakeButton.href=matchingQuizUrl.link;
    quizRetakeButton.style.display="flex";
    return quizRetakeButton;
  }
  else{
    return null;
  }
}

const appendElementNextTo = (target_element_id,new_element) => {
  let target_element = document.getElementById(target_element_id);
  target_element.parentNode.insertBefore(new_element, target_element.nextSibling)
}

// Product available / active
function checkForProductValidity(product_sections,product_list,section,idx,selected_variant){
  var cart_button = document.getElementById(section+'_cart_tangent_product_' + idx + '_text');
  if(cart_button!=undefined){
    // Check if Product is active
    if (product_list[idx].status == "active") {
          cart_button.classList.remove("disable-btn-wrapper");
          if(selected_variant.inventory_policy == "deny"){
              if(selected_variant.inventory_quantity<1){
                if(selected_variant.inventory_management!=null){
                  cart_button.innerHTML = out_of_stock_text;
                  cart_button.classList.add("disable-btn-wrapper");
                }
                else{
                    updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
                }
              }
              else{
                updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
              }
          }
          else{
            updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
        }
    }
    else {
        cart_button.innerHTML = out_of_stock_text;
        cart_button.classList.add("disable-btn-wrapper");
    }
  } 
}
// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;

    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "flex" : "none";
                }
            }
        }
    }
}


// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}


const getVariantImage = (imageId, product) => {
    var pdtImg;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    pdtImg = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            pdtImg = product.image.src;
        }
        else{
            pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(pdtImg== undefined || pdtImg==null){
        pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return pdtImg;
}

function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => {
      const item = {
        id: Number(id),
        quantity: 1
      };

      if (SELLING_PLAN_MAP[id]) {
        item.selling_plan = SELLING_PLAN_MAP[id];
      }

      return item;
    })
  };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}



const createElement = (button_id, element_type) =>{
  const element = document.createElement(element_type);
  element.id=button_id;
  return element;
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

  const ctx = canvas.getContext( '2d' );
  const bb = canvas.getBoundingClientRect();
  var point = {
    _x:Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
    _y:Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
  }

  var skin_conditions = ["acne","darkspots","wrinkles","dark_circles","rosacea"];
  var click_found = false;
  for(var sc=0;sc <skin_conditions.length;sc++){
    if(isPointInsidePoligon(point,tangent_facemap_data[skin_conditions[sc]])){
      openConditionMessage(canvas,skin_conditions[sc]);
      click_found=true;
      break;
    }
  }
  if(!click_found){
    tangent_condition_message_popoup.style.display="none";
    console.log("no condition click");
  }
}

function openConditionMessage(canvas,condition){
  tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
  let rect = canvas.getBoundingClientRect();
  var point = {
    _x:event.clientX - rect.left,
    _y:event.clientY - rect.top
  }
  console.log("point click",point);
  
  // Positioning Popup
  Object.assign(
    tangent_condition_message_popoup.style,
    {
      display:"block",
      left:(point._x) +"px",
      top:(point._y) +"px"
    }
  );
}

// Custom function for scroll to operation
function scrollToElement(element_id){
  let element;
  if(element_id=="daily_wellbeing"){
     element = document.getElementById('shopify-section-template--16909643743394__featured_text_wH7DN3');
  }
  if(element!=undefined){
    element.scrollIntoView();
  }
}

// Check whether click is inside condition points
function  isPointInsidePoligon(pt, points_list) {
    // https://stackoverflow.com/a/29915728/960654
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
      
    var x = pt._x,
      y = pt._y

    var inside = false;
    for(var c=0;c<points_list.length;c++){
      var points = points_list[c];
      for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
        var xi = points[i][0],
          yi = points[i][1]
        var xj = points[j][0],
          yj = points[j][1]
  
        var intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
        if (intersect) inside = !inside
      }
    }
    return inside
  }

// Toggle - hide higlight button
function hideHightlightButtonDisplayToggle(display){
  document.querySelector("#hideHighlight").style.display=display;
}

// Toggle - show highlight button
function showHighlightButtonDisplayToggle(display) {
  document.querySelector("#showHighlight").style.display=display;  
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Toggle hide highlight and show highlight
function toggleHighlight(status){
  if(status){
    hideHightlightButtonDisplayToggle("block");
    showHighlightButtonDisplayToggle("none");
    selfieCanvasDisplayToggle("block");
  }
  else{
    hideHightlightButtonDisplayToggle("none");
    showHighlightButtonDisplayToggle("block");
    selfieCanvasDisplayToggle("none");
  }
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    if(section_name != "section_products" && section_name != "section_skincare_routine" && section_name != "section_skincare_ritual" && section_name != "section_youtube_link"){
    section_container.classList.add("tabcontent");
    }
    return section_container;
}

// // Add to cart button for sections
// function createSectionAddAllToCart(section_name) {
//     var add_all_to_cart_p_tag = document.createElement("p");
//     add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
//     add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
//     add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

//     var add_all_cart_link = document.createElement("a");
//     add_all_cart_link.id = section_name+"_add_all_cart_link";
//     add_all_cart_link.classList.add("section_add_all_cart_link");
//     add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
//     add_all_cart_link.innerHTML = "Add all to Cart";

//     // Enabling listener
//     add_all_cart_link.addEventListener(
//         'click',
//         function () { addAllTocartFunction(section_name); },
//         false
//     );
//     add_all_to_cart_p_tag.appendChild(add_all_cart_link);
//     return add_all_to_cart_p_tag;
// }


function createSectionAddAllToCart(section_name) {
    const button = document.createElement("button");
    button.id = `${section_name}`;
    button.classList.add("section_add_all_to_cart","btn", `${section_name}_add_all_to_cart`);
    button.innerHTML = default_add_all_to_cart_text;
    button.setAttribute("aria-label", `Add all ${section_name} items to cart`);
    button.addEventListener('click', () => addAllTocartFunction(button));
    return button;
}


// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    //   createTabButton(section_name);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);
            
            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_selfie.appendChild(section_container);
            }
            else if(section_name == 'section_additional_content'){
              var section_additional = document.querySelector("#section_additional_content_container_parent");
              section_container.classList.remove('tabcontent');   
              section_additional.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      hideHightlightButtonDisplayToggle("flex");
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          hideHightlightButtonDisplayToggle("flex");
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                console.log("inside check image")
                hideLoading();
                showSelfieImage();
                document.querySelector('#canvas_img').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}

// Enabling button listeners
function enableButtonListener() {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.tangent-product-add-btn-wrapper');
    if (!btn) return;

    addToCart(btn);
  });
}

// Selfie Mapping data api call
function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango" 
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              tangent_facemap_data = response_json["selfie_record"][0].facemap;
              setScores(tangent_facemap_data.scores);
              document.querySelector("#canvas_img").setAttribute("src",tangent_facemap_data.url);
             
              hideLoading();
              showSelfieImage();
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

// Show Selfie Image
function showSelfieImage(){
  document.querySelector("#canvas_img").style.display = "block";
}

function findFirstMatchingQuiz(data, tags) {
    return data.find(item => tags.includes(item.tag)) || null;
}

// Setting scores below the selfie
function setScores(scores){
  var scores_present = false;
  var concern_count = 0;
  Object.keys(scores).forEach(key => {
    const value = scores[key];
    switch(key) {
      case "acne":
          document.querySelector("#Acne_Score_container").style.display="flex";
          document.querySelector("#Acne_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "rosacea":
          document.querySelector("#Rosacea_Score_container").style.display="flex";
          document.querySelector("#Rosacea_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "darkspots":
          document.querySelector("#DarkSpots_Score_container").style.display="flex";
          document.querySelector("#DarkSpots_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "wrinkles":
          document.querySelector("#Wrinkles_Score_container").style.display="flex";
          document.querySelector("#Wrinkles_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "dark_circles":
          document.querySelector("#DarkCircles_Score_container").style.display="flex";
          document.querySelector("#DarkCircles_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "texture":
          document.querySelector("#Texture_Score_container").style.display="flex";
          document.querySelector("#Texture_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      default:
        break;
        // No Concerns Found
    }
  });

  // Show only if atleast one concern is found
  if(scores_present){
    document.querySelector("#facemap_all_scores_container").style.display="flex";
  }
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas(){
    if(getSelfieId()!=null){
      
      var selfie_canvas = document.querySelector('#selfie_canvas');
      var selfie_canvas_ctx = selfie_canvas.getContext('2d');
      
      selfie_canvas.addEventListener('click', function(e) {
          getCursorPosition(selfie_canvas, e)
      });
      
      var canvas_img = document.querySelector('#canvas_img');
      setCanvasDimensions(selfie_canvas, canvas_img);
      
      var prop = getImageSize(canvas_img.naturalWidth);
      
      drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
      drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
      drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
      drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
      drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
      drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"],getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width  = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop =  imgWidth/400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if(prop<1){
    return 'blur(1px)';
  }
  else if(prop<1.5){
    return 'blur(2px)';
  }
  else if(prop<2){
    return 'blur(4px)';
  }
  else if(prop<3){
    return 'blur(7px)';
  }
  else if(prop<4){
    return 'blur(12px)';
  }
  else{
    
  }
}

const getRosaceaBlur = (prop) => {
  if(prop<1){
    return 'blur(4px)';
  }
  else if(prop<1.5){
    return 'blur(4px)';
  }
  else if(prop<2){
    return 'blur(5px)';
  }
  else if(prop<3){
    return 'blur(13px)';
  }
  else if(prop<4){
    return 'blur(18px)';
  }
  else{
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 7;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - Acne");    
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if(prop<1){
    return 1;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 6;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - DarkSpots");    
  }
}

const getTextureLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 3;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 16;
  }
  else{
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 15;
  }
  else if(prop<4){
    return 30;
  }
  else{
    console.log("out of bound props - Wrinkle");    
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill=false, stroke=false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}